import { Component } from '@angular/core';
import { CustomWidget } from '../widget';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'abb-rich-text-widget',
  standalone: true,
  imports: [QuillModule, FormsModule],
  template: `
    <quill-editor
    [className]="'w-full'"
      name="rich-text-editor"
      [ngModel]="this.widget().customText ?? ''"
      [format]="'html'"
      [readOnly]="true"
      [modules]="{
        toolbar: false
      }"
    ></quill-editor>
  `,
  styles: [
    `
      ::ng-deep .ql-container {
        background-color: white !important;
      }
    `
  ],
})
export class RichTextWidgetComponent extends CustomWidget {
}
